module.exports = __webpack_public_path__ + "static/media/mastercard-logo.fed78b6d.png";